// 🔧 passport_builder.js
// ✅ Purpose: Orchestrates Passport demo data creation
// ✅ Features:
// - Generates adaptive Passport stops from available demo context
// - Seeds Passport stops, rewards, achievements, and demo progress
// - Updates DemoContext with Passport results
// - Returns standardized Demo Report results
// - Fully block-commented for clarity and future devs

import { generatePassport } from "./passport_generator";
import { seedPassport } from "./passport_seeder";
import { buildPassportReport } from "./passport_report";

export const buildPassport = async ({ demoContext } = {}) => {
  console.log("🛂 Passport Builder started.");

  const passportPlan = generatePassport({ demoContext });

  const passportResults = await seedPassport({
    demoContext,
    passportPlan,
  });

  demoContext.passport = {
    stops: passportResults.stops || [],
    rewards: passportResults.rewards || [],
    achievements: passportResults.achievements || [],
    progress: passportResults.progress || [],
  };

  return buildPassportReport({ passportResults });
};